"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationStatus = void 0;
var ValidationStatus;
(function (ValidationStatus) {
    ValidationStatus["PENDING"] = "Pending";
    ValidationStatus["VALIDATING"] = "Validating";
    ValidationStatus["VALID"] = "Valid";
    ValidationStatus["INVALID"] = "Invalid";
    ValidationStatus["INVALID_JSON"] = "Invalid JSON";
    ValidationStatus["NOT_COMPLETE"] = "Not Complete";
})(ValidationStatus = exports.ValidationStatus || (exports.ValidationStatus = {}));
